import { C__LanguageSelector } from './c--language-selector/C__LanguageSelector';
import { C__MenuMegaMain } from './c--menu-mega-main/C__MenuMegaMain';
import { C__RecommemdedProductsNotifier } from './c--recommended-products-notifier/C__RecommemdedProductsNotifier';
import { C__SearchForm } from './c--search-form/C__SearchForm';
import { C__Form } from './c--form/C__Form';

export const Components = {
    directives: {},
    modules: {
        C__LanguageSelector,
        C__MenuMegaMain,
        C__RecommemdedProductsNotifier,
        C__SearchForm,
        C__Form
    }
};
